// extracted by mini-css-extract-plugin
export default {"option":"options__option--S4Xrz","name":"options__name--x9VUZ","price":"options__price--mVEzZ","layout":"options__layout--ayR3z"};